// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yw8L","colBig":"styles_colBig__KhjQi","colSmall":"styles_colSmall__2l8Hi"};